var deprecatedIconNames = [
    'PaymentMixedIcon',
    'PaymentCashIcon',
    'PaymentCardIcon',
    'PaymentGiftIcon',
    'AlertIcon',
    'BackIcon',
    'CampaignsIcon',
    'CancelIcon',
    'CartIcon',
    'ClearInputIcon',
    'ContentCopyIcon',
    'DollarSignIcon',
    'DownIcon',
    'EmailIcon',
    'FileUploadInvertedIcon',
    'InfoIcon',
    'LeftIcon',
    'OptionsIcon',
    'OptionsVerticalIcon',
    'ParenthesisIcon',
    'QuestionMarkIcon',
    'ReviewsIcon',
    'RightIcon',
    'RotationIcon',
    'TagIcon',
    'VerticalsIcon',
    'UpIcon',
    'CheckCircleIcon',
    'AddCircleIcon',
    'CancelCircleIcon',
    'SelectArrowUpIcon',
    'SelectArrowDownIcon',
    'UserIcon',
    'ScooterIcon',
    'LocationPinIcon',
    'LoyaltyRewards',
    'Lock',
    'NewCustomerIcon',
    'RemoveCartIcon',
    'ViewIcon',
    'ContentCopyFilledIcon',
    'FlipIcon',
    'ReloadIcon',
    'DailyIcon',
    'WalletIcon',
    'PlusIcon',
    'MinusIcon',
    'PaymentIcon',
    'MoreThanIcon',
    'LessThanIcon',
];
var deprecatedCorrespondingIcons = {
    PaymentMixedIcon: 'PmUnidentifiedIcon',
    PaymentCashIcon: 'PmCashIcon',
    PaymentCardIcon: 'PmMastercardIcon',
    PaymentGiftIcon: 'PmUnidentifiedIcon',
    AlertIcon: 'WarningIcon',
    BackIcon: 'ArrowLeftIcon',
    CampaignsIcon: 'CampaignIcon',
    CancelIcon: 'CloseIcon',
    CartIcon: 'ShoppingCartIcon',
    ClearInputIcon: 'ClearSolidIcon',
    ContentCopyIcon: 'DuplicateIcon',
    DollarSignIcon: 'MoneyIcon',
    DownIcon: 'ChevronDownIcon',
    EmailIcon: 'MailIcon',
    FileUploadInvertedIcon: 'FileUploadIcon',
    InfoIcon: 'InformativeIcon',
    LeftIcon: 'ChevronLeftIcon',
    OptionsIcon: 'MoreHorizontalIcon',
    OptionsVerticalIcon: 'MoreVerticalIcon',
    QuestionMarkIcon: 'HelpIcon',
    ReviewsIcon: 'FeedbackIcon',
    RightIcon: 'ChevronRightIcon',
    RotationIcon: 'RotateIcon',
    TagIcon: 'DealIcon',
    VerticalsIcon: 'AppsIcon',
    UpIcon: 'ChevronUpIcon',
    CheckCircleIcon: 'CheckIcon',
    AddCircleIcon: 'AddIcon',
    CancelCircleIcon: 'CloseIcon',
    SelectArrowUpIcon: 'ExpandIcon',
    SelectArrowDownIcon: 'CollapseIcon',
    UserIcon: 'CustomerIcon',
    ScooterIcon: 'DeliveryIcon',
    LocationPinIcon: 'LocationIcon',
    LoyaltyRewards: 'LoyaltyBrandIcon',
    Lock: 'LockIcon',
    NewCustomerIcon: 'AddMemberIcon',
    RemoveCartIcon: 'RemoveIcon',
    ViewIcon: 'VisibilityOnIcon',
    ContentCopyFilledIcon: 'DuplicateIcon',
    FlipIcon: 'FlipVerticalIcon',
    ReloadIcon: 'HistoryIcon',
    DailyIcon: 'SalesIcon',
    WalletIcon: 'LaborIcon',
    PlusIcon: 'AddIcon',
    MinusIcon: 'RemoveIcon',
    PaymentIcon: 'PmCashIcon',
    MoreThanIcon: 'MoreIcon',
    LessThanIcon: 'LessIcon',
};

export { deprecatedCorrespondingIcons, deprecatedIconNames };
